"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Copyright 2017-2018 The MathWorks, Inc.
define(["./_polyfills/_addEventListenerOptions", "./_polyfills/_createEvent", "./_polyfills/_PatchedHtmlElement", "custom-elements/custom-elements.min"], function (_addEventListenerOptions, _createEvent, _PatchedHtmlElement) {

    // no-op (no operation) function
    var noOp = function noOp() {};

    var WidgetBase = function (_PatchedHtmlElement2) {
        _inherits(WidgetBase, _PatchedHtmlElement2);

        function WidgetBase() {
            _classCallCheck(this, WidgetBase);

            var _this = _possibleConstructorReturn(this, (WidgetBase.__proto__ || Object.getPrototypeOf(WidgetBase)).call(this));

            _this._root = document.createDocumentFragment();
            return _this;
        }

        _createClass(WidgetBase, [{
            key: "init",
            value: function init() {}
        }, {
            key: "connectedCallback",
            value: function connectedCallback() {
                if (!this._connectedCallbackRan) {
                    this.init();
                    this.appendChild(this._root);
                    delete this._root;
                    this._connectedCallbackRan = true;
                }
            }
        }, {
            key: "disconnectedCallback",
            value: function disconnectedCallback() {}
        }, {
            key: "adoptedCallback",
            value: function adoptedCallback() {}
        }, {
            key: "attributeChangedCallback",
            value: function attributeChangedCallback(name, oldValue, newValue) {}

            /**
             * Emits custom events from the widget.
             *
             * @param {string} eventName name of the event
             * @param {object} data an object with the
             * data that should be attached to the event
             * this ends up in the event's detail
             * @param {object} options an options object.
             * Can specify cancelable, bubbles (defaults
             * bubbles: false, canceable: false)
             */

        }, {
            key: "emit",
            value: function emit(eventName, data) {
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

                this.dispatchEvent(_createEvent.createEvent(eventName, data, options));
            }

            /**
             * Listens on events that the widget throws.
             * @param {string} eventName The name of the event to listen on
             * @param {function} callback The function to call when the event occurs
             * @param {object} options an object that specifies if the event should be
             * passive, capture (defaults - passive: browser/event dependent,
             * capture: false)
             * @returns {object} - object with a remove function.  Calling remove twice
             * does nothing
             */

        }, {
            key: "on",
            value: function on(eventName, callback) {
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

                var eventObj = _addEventListenerOptions.getOptions(options);
                this.addEventListener(eventName, callback, eventObj);

                var removeFn = this.removeEventListener.bind(this, eventName, callback, eventObj);
                return {
                    remove: function remove() {
                        removeFn();
                        removeFn = noOp;
                    }
                };
            }
        }]);

        return WidgetBase;
    }(_PatchedHtmlElement);

    ;
    return WidgetBase;
});

